export default __webpack_public_path__ + "static/media/walking_man_prac.8f118608.svg";